// extracted by mini-css-extract-plugin
export default {"ButtonStyle":"NewCreateMenu__ButtonStyle___MwLq4","NewCreateMenu":"NewCreateMenu__NewCreateMenu___qdBhe"};